import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const PressReleases = lazy(() => import("@/pages/info/PressReleases"));

export const Route = createFileRoute("/pressreleaser/")({
  head: () => seoHead("/pressreleaser"),
  component: () => <PressReleases />,
});
